import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ReactPlayer from "react-player";

import Back from "../../../../../assets/images/back.png";

import "./summary.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { fetchStudentCoursePlanObject } from "../../../../../store/actions/coursePlansAction";

import {
  markSummaryAsComplete,
  fetchSummaryTrack,
  markParaSummary,
  markOpenSummary,
  markSummaryFlipped,
  markSummaryReadListenStatus,
  markSummaryVideoOpened,
} from "../../../../../store/actions/summaryActions";

import { Button, TreeSelect, Tooltip, notification, message } from "antd";

import { InfoCircleTwoTone } from "@ant-design/icons";

import { Container, Row, Col } from "react-bootstrap";

import Confetti from "react-confetti";
import Audio from "../../../../../assets/images/audio.png";

import {
  student,
  STUDENT_CONTENT_BASE_URL,
  TUTOR,
} from "../../../../../constants/LookupConst";
import studybuddyService from "../../../../../services/studybuddy/studybuddyService";
import { socket } from "../../../../../Socket";
import sessionService from "../../../../../services/session/sessionService";
import utils from "../../../../../util/utils";

const { TreeNode } = TreeSelect;

let aContext;
let started = false;
let i = 0,
  j = 0,
  contentlen = 0;
let bulb = 0;
let time;
let userflipped = 0;

//the narrative is chunked on a space, but a space inside a tag (`<break time="2s"/>`)
//would split the tag across two chunks and both halves get dropped, losing the pause.
//find the last space at or before `limit` that sits outside any `<...>` tag
const lastSpaceOutsideTag = (text, limit) => {
  let k = text.lastIndexOf(" ", limit - 1);
  while (k > -1) {
    const open = text.lastIndexOf("<", k);
    if (open === -1) return k;
    const close = text.indexOf(">", open);
    //the tag opened before this space is already closed before it, so the space is free
    if (close > -1 && close < k) return k;
    //space is inside that tag - keep looking from before the tag starts
    k = text.lastIndexOf(" ", open - 1);
  }
  return -1;
};
const userData = sessionService.getLoggedUserData();

class Summary extends React.Component {
  frameRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      showReturnBtn: true,
      starttime: new Date(),
      onparagraph: 1,
      totalpara: 0,
      timespend: 0,
      playbackrate: "100%",
      playbacktxt: "Normal",
      tutor: "Ruth",
      content: "",
      contentwithflip: "",
      isbegin: false,
      action: "",
      seekValue: 1,
      totalflip: 0,
      fliped: 0,
      showConfetti: false,
      showReturnToCP: false,
      isreadcomplete: false,
      islistencomplete: false,
      fontSize: Number(localStorage.getItem("fontSize")) || 14,
      fontFamily: localStorage.getItem("fontFamily") || "Arial",
      videolink: "",
      isvideoopened: false,
      isvideocomplete: false,
      // onlylisten: false,
    };

    this.handleflipmouseover = this.handleflipmouseover.bind(this);
    this.handleflipmouseout = this.handleflipmouseout.bind(this);
  }

  fetchUserRole = (roles) => {
    const data =
      roles && roles.length > 0 && roles.find((p) => p.id === userData?.id);
    const userRole = data ? data.role : "";

    return userRole;
  };

  async componentDidMount() {
    const { match, customNotes, id, location } = this.props;
    let params = {};
    const sessionData = await studybuddyService.fetchSessionData();

    await socket.on("recviceUpdateWaitingStatusForNarrative", (data) => {
      if (userData?.id === data?.msgto) {
        if (data?.path) {
          this.setState({
            loading: true,
          });
          const newPath = `${data.path}/studybuddy`;
          window.location.href = newPath;
        }
      }
    });

    if (
      sessionData &&
      sessionData?.isactive &&
      sessionData?.sessionmode == TUTOR
    ) {
      // Fetch user roles from the service
      const result = await studybuddyService.fetchRoles();
      const currentRoute = location.pathname;
      const userRole = this.fetchUserRole(result?.roles);
      if (sessionData?.sessionmode === TUTOR && userRole === student) {
        socket.emit("sendNarrativeInvite", {
          sessionData: sessionData,
          currentRoute: currentRoute,
          inviteTo:
            userData?.id === sessionData?.invitationto?.id
              ? sessionData?.invitationfrom?.id
              : sessionData?.invitationto?.id,
        });
      }
    }

    if (customNotes) {
      params = {
        id,
      };
    } else {
      params = match.params;
    }

    await this.props.fetchStudentCoursePlanObject(params.id);

    let content = "";
    const ndata = this.props.selectedCoursePlanObject.sourceid;
    const round = this.props.selectedCoursePlanObject.round;

    // this.setState({
    //   onlylisten: ndata.onlylisten && ndata.onlylisten === true ? true : false,
    // });

    //MULTIVERSION & KICONTENT/NON KI CONTENT LOGIC
    if (ndata && ndata.hierarchytype === "KIContent") {
      //KI of the course plan
      const courseplanKI = this.props.selectedCoursePlanObject.courseplanKI;

      //sections data
      for (let i = 0; i < ndata.sectioncontents.length; i++) {
        //section data
        const section = ndata.sectioncontents[i];
        let kitems = section.knowledgeitems;
        let sectioncontent = section.content;

        if (ndata.ismultiversion === true) {
          if (round === 2) {
            if (section.knowledgeitemsv2 && section.knowledgeitemsv2.length > 0)
              kitems = section.knowledgeitemsv2;

            if (section.contentv2 && section.contentv2 !== "")
              sectioncontent = section.contentv2;
          } else if (round >= 3) {
            if (section.knowledgeitemsv3 && section.knowledgeitemsv3.length > 0)
              kitems = section.knowledgeitemsv3;
            if (section.contentv3 && section.contentv3 !== "")
              sectioncontent = section.contentv3;
          }
        }

        if (kitems && kitems.length > 0) {
          for (let k = 0; k < kitems.length; k++) {
            //console.log("kitems[k]._id: ", k, kitems[k]._id, kitems);
            let ki = kitems[k]._id.toString();
            let kiname = kitems[k].kiname;
            if (
              (courseplanKI && courseplanKI.indexOf(ki) !== -1) ||
              kiname === "UNCATEGORIZED"
            ) {
              content = content + "<p>" + sectioncontent + " \n\n";
              break;
            }
          }
        } else {
          content = content + "<p>" + sectioncontent + " \n\n";
        }
      }
    } else {
      let sectioncontent = ndata ? ndata.content : "";
      if (ndata && ndata.ismultiversion === true) {
        if (round === 2 && ndata.contentv2 !== "")
          sectioncontent = ndata.contentv2;
        else if (round >= 3 && ndata.contentv3 !== "")
          sectioncontent = ndata.contentv3;
      }
      content = sectioncontent;
    }

    //check if any track is already exists
    await this.props.fetchSummaryTrack({
      studentcpid: params.id,
      isrepeated: false,
      repeatcount: 0,
      round: this.props.selectedCoursePlanObject.round,
    });

    if (ndata && ndata.isvideotype && ndata.isvideotype === true) {
      this.setState({
        videolink: ndata.videolink,
        isvideoopened: this.props.summarytrack
          ? this.props.summarytrack.isvideoopened
          : false,
        isvideocomplete: this.props.summarytrack
          ? this.props.summarytrack.isvideocomplete
          : false,
      });
    }

    //RESUME text
    if (this.props.summarytrack && this.props.summarytrack.onparagraphweb > 0) {
      document.getElementsByClassName("btnPause")[0].innerText = "Resume";
      document.getElementsByClassName("btnPause")[1].innerText = "Resume";
    }

    //PLAY FROM BEGINING SETTING
    if (this.props.summarytrack && this.props.summarytrack.onparagraphweb > 1)
      this.setState({ isbegin: true });

    //content with flip keyword setting
    let contentwithflip = content;
    contentwithflip = contentwithflip.replace(/\n/g, "<br />");

    //KIRAN(27apr2026) : Bruce wants to remove flip from Answer
    //replace all <keyword>Answer: with only Answer:
    contentwithflip = contentwithflip.replace(/<keyword>Answer:/g, "Answer:");

    let k = 0;
    let answerstart = false;
    let answerdata = "";

    let alldata = content.split(/\n\n|\n| /);
    alldata.forEach((data, index) => {
      if (
        data.startsWith("<keyword>Answer:") ||
        data.startsWith("<keywords>") ||
        answerstart === true
      ) {
        if (data.startsWith("<keywords>")) answerstart = true;

        if (answerstart === false) {
          ++k;

          var outerspan1 = document.createElement("span");
          var innerspan1 = document.createElement("span");
          innerspan1.id = "k" + k.toString();
          innerspan1.className = "animatin-text";
          innerspan1.innerHTML = data.replace("<keyword>", "");

          outerspan1.appendChild(innerspan1);
          contentwithflip = contentwithflip.replace(data, outerspan1.outerHTML);

          answerstart = true;
        } else {
          if (data.startsWith("<p>") || index === alldata.length - 1) {
            ++k;

            var outerspan2 = document.createElement("span");
            var innerspan2 = document.createElement("span");
            innerspan2.id = "k" + k.toString();
            innerspan2.className = "animatin-text";
            innerspan2.innerHTML = answerdata.replace("<keyword>", "");

            outerspan2.appendChild(innerspan2);
            contentwithflip = contentwithflip.replace(
              answerdata,
              outerspan2.outerHTML
            );

            answerstart = false;
            answerdata = "";
          } else {
            answerdata = answerdata + " " + data;
          }
        }
      } else if (data.startsWith("<keyword>")) {
        ++k;

        //fix
        data = data.split(".")[0];

        var outerspan = document.createElement("span");
        var innerspan = document.createElement("span");
        innerspan.id = "k" + k.toString();
        innerspan.className = "animatin-text";
        innerspan.innerHTML = data.replace("<keyword>", "");

        outerspan.appendChild(innerspan);
        contentwithflip = contentwithflip.replace(data, outerspan.outerHTML);
      }
    });

    const fcnt = (contentwithflip.match(/animatin-text/g) || []).length;
    //console.log("fcnt: ", fcnt);

    let isreadc = false;
    if (
      this.props.summarytrack &&
      this.props.summarytrack.isreadcomplete === true
    ) {
      isreadc = true;
    } else {
      isreadc = fcnt === 0 ? true : false;
    }

    let islistenc = false;
    if (
      this.props.summarytrack &&
      this.props.summarytrack.islistencomplete === true
    ) {
      islistenc = true;
    }

    //set default tutor if tutor is not from the list
    let finaltutor = "Ruth";
    switch (this.props.selectedCoursePlanObject.tutor) {
      case "Ruth":
      case "Matthew":
      case "Stephen":
      case "Joanna":
      case "Emma":
      case "Kimberly":
      case "Brian":
        finaltutor = this.props.selectedCoursePlanObject.tutor;
        break;
      default:
        finaltutor = "Ruth";
        break;
    }

    //take if any before time
    let ts = this.props.summarytrack
      ? this.props.summarytrack.totaltimespendweb
        ? this.props.summarytrack.totaltimespendweb
        : 0
      : 0;

    this.setState({
      tutor: finaltutor,
      content: content,
      contentwithflip: contentwithflip,
      totalflip: fcnt,
      isreadcomplete: isreadc,
      islistencomplete: islistenc,
      timespend: ts,
    });

    document.body.addEventListener("mouseover", this.handleflipmouseover);
    document.body.addEventListener("mouseout", this.handleflipmouseout);
  }

  async componentWillUnmount() {
    i = j = contentlen = 0;
    started = false;
    userflipped = 0;

    let startDate = this.state.starttime;
    let endDate = new Date();
    let seconds = Math.round((endDate.getTime() - startDate.getTime()) / 1000);

    if (seconds > 15) {
      await this.props.markOpenSummary({
        studentcpid: this.props.match.params.id,
        isrepeated: false,
        repeatcount: 0,
        round: this.props.selectedCoursePlanObject.round,
      });
    }

    if (aContext && aContext.state !== "closed") {
      aContext.close().then(function () {});
    }

    document.body.removeEventListener("mouseover", this.handleflipmouseover);
    document.body.removeEventListener("mouseout", this.handleflipmouseout);
  }

  handleflipmouseover = async (evt) => {
    if (evt.target.className === "animatin-text") {
      time = setTimeout(() => {
        bulb = 1;
      }, 500);
    }
  };

  handleflipmouseout = async (evt) => {
    if (evt.target.className === "animatin-text") {
      if (bulb === 1) {
        evt.target.className = "animatin-text animatin";
        bulb = 0;
        clearTimeout(time);

        const tot = this.state.totalflip;
        const comp = tot < 5 ? tot : 5;

        let fliped = userflipped;
        fliped = fliped + 1;
        userflipped++;

        if (fliped >= comp) {
          await this.props.markSummaryFlipped({
            studentcpid: this.props.match.params.id,
            isrepeated: false,
            repeatcount: 0,
            round: this.props.selectedCoursePlanObject.round,
          });
        }

        const isreadcomplete = fliped >= tot ? true : false;
        const evalreadcomplete =
          this.state.isreadcomplete === true ? true : isreadcomplete;

        this.setState({
          fliped: fliped,
          isreadcomplete: evalreadcomplete,
        });

        //If all boxes are opened
        if (isreadcomplete === true) {
          //if study project narrative then it should not needed to comeplete the listening
          if (
            this.props.selectedCoursePlanObject.cpoid.cponame ===
            "Interactive Podcast"
          ) {
            this.setState({ islistencomplete: true });
          } else if (
            this.props.selectedCoursePlanObject.round === 1 &&
            this.state.islistencomplete !== true
          ) {
            //for first round both read and listen are compulsary for completion

            notification.info({
              message: "Narrative",
              description:
                "Thanks for reading the narrative. Next, you must listen to the narrative for the narrative to be marked as complete.",
              placement: "topRight",
            });

            await this.props.markSummaryReadListenStatus({
              studentcpid: this.props.match.params.id,
              isrepeated: false,
              repeatcount: 0,
              round: this.props.selectedCoursePlanObject.round,
              isreadcomplete: evalreadcomplete,
              islistencomplete: this.state.islistencomplete,
            });

            return;
          }

          this.setState({
            showReturnBtn: true,
            showConfetti: true,
            showReturnToCP: true,
          });

          //total time spend till the time
          let ts = this.state.timespend;
          let starttime = this.state.starttime;
          var endtime = new Date();
          var diff = endtime.getTime() - starttime.getTime();
          var seconds = Math.floor(diff / 1000);
          //console.log("ts before calculate : ", ts);
          ts = ts + seconds;
          this.setState({ timespend: ts });
          //console.log("ts in calculated : ", seconds, ts);
          //-----------------------------------

          //check if any track is already exists
          await this.props.fetchSummaryTrack({
            studentcpid: this.props.match.params.id,
            isrepeated: false,
            repeatcount: 0,
            round: this.props.selectedCoursePlanObject.round,
          });

          //mark the CPO as complete
          await this.props.markSummaryAsComplete({
            studentcpid: this.props.match.params.id,
            isrepeated: false,
            repeatcount: 0,
            round: this.props.selectedCoursePlanObject.round,
            trackid: this.props.summarytrack ? this.props.summarytrack._id : "",
            totaltimespend: ts,
            playbackrate: this.state.playbacktxt,
            tutor: this.state.tutor,
            isreadcomplete: evalreadcomplete,
            islistencomplete: this.state.islistencomplete,
          });
        }
      }
    }
  };

  markSummaryAsComplete = async (flag, from = "other") => {
    const { selectedCoursePlanObject, match, customNotes, id } = this.props;
    let params = customNotes ? { id } : match.params;

    // if (this.state.onlylisten === true) {
    //   this.setState({ isreadcomplete: true });
    // }

    if (aContext && aContext.state !== "closed") {
      aContext.close().then(function () {});
    }

    //total time spend till the time
    let ts = this.state.timespend;
    let starttime = this.state.starttime;
    var endtime = new Date();
    var diff = endtime.getTime() - starttime.getTime();
    var seconds = Math.floor(diff / 1000);
    //console.log("ts before calculate : ", ts);
    ts = ts + seconds;
    this.setState({ timespend: ts });
    //console.log("ts in calculated : ", seconds, ts);
    //-----------------------------------

    //check if any track is already exists
    await this.props.fetchSummaryTrack({
      studentcpid: params.id,
      isrepeated: false,
      repeatcount: 0,
      round: this.props.selectedCoursePlanObject.round,
    });

    if (j + 1 >= contentlen && flag === true) {
      //set state as false
      started = false;
      i = j = contentlen = 0;

      //reset button text
      //document.getElementById("btnPause").innerText = "Play";
      document.getElementsByClassName("btnPause")[0].innerText = "Play";
      document.getElementsByClassName("btnPause")[1].innerText = "Play";

      this.setState({ islistencomplete: true });

      //if study project narrative then it should not needed to comeplete the listening
      if (
        this.props.selectedCoursePlanObject.cpoid.cponame ===
        "Interactive Podcast"
      ) {
        this.setState({ isreadcomplete: true });
      } else if (
        selectedCoursePlanObject.round === 1 &&
        this.state.isreadcomplete !== true
      ) {
        //for first round both read and listen are compulsary for completion
        notification.info({
          message: "Narrative",
          description:
            "Thanks for listening to the narrative. Next, you must read the narrative for the narrative to be marked as complete.",
          placement: "topRight",
        });

        await this.props.markSummaryReadListenStatus({
          studentcpid: this.props.match.params.id,
          isrepeated: false,
          repeatcount: 0,
          round: this.props.selectedCoursePlanObject.round,
          isreadcomplete: this.state.isreadcomplete,
          islistencomplete: true,
        });

        return;
      }
      //-------------------------------------------------------------------

      this.setState({
        showReturnBtn: true,
        showConfetti: true,
        showReturnToCP: true,
      });
      //mark the CPO as complete
      await this.props.markSummaryAsComplete({
        studentcpid: params.id,
        isrepeated: false,
        repeatcount: 0,
        round: selectedCoursePlanObject.round,
        trackid: this.props.summarytrack ? this.props.summarytrack._id : "",
        totaltimespend: ts,
        playbackrate: this.state.playbacktxt,
        tutor: this.state.tutor,
        isreadcomplete: this.state.isreadcomplete,
        islistencomplete: true,
      });
    } else {
      //coming from two ways, either STOP or automatically after selection end
      let paragraphC = this.state.onparagraph;

      started = false;
      if (from === "stop") {
        //reset button text/ STOP BUTTON CLICK
        //document.getElementById("btnPause").innerText = "Play";
        document.getElementsByClassName("btnPause")[0].innerText = "Play";
        document.getElementsByClassName("btnPause")[1].innerText = "Play";

        this.setState({ showReturnBtn: true });
      } else {
        i = j + 1;
        let browserText = this.state.content ? this.state.content : "";
        let arrpara = browserText.trim().split("<p>");

        //setup para
        let sum = 0;
        for (let p = 0; p < arrpara.length; p++) {
          sum += arrpara[p].length;
          if (sum >= i) {
            paragraphC = p;
            this.setState({ onparagraph: p });
            break;
          }
        }
        //AUTO DIRECTED
        //document.getElementById("btnPause").click();
        document.getElementsByClassName("btnPause")[0].click();
      }

      await this.props.markParaSummary({
        studentcpid: params.id,
        isrepeated: false,
        repeatcount: 0,
        round: selectedCoursePlanObject.round,
        trackid: this.props.summarytrack ? this.props.summarytrack._id : "",
        onparagraph: paragraphC,
        totaltimespend: ts,
        playbackrate: this.state.playbacktxt,
        tutor: this.state.tutor,
      });
    }
  };

  onHandleVideoPlayEnd = async (from = "start") => {
    const { selectedCoursePlanObject, match, customNotes, id } = this.props;
    let params = customNotes ? { id } : match.params;

    if (aContext && aContext.state !== "closed") {
      aContext.close().then(function () {});
    }

    if (from === "start") {
      this.setState({ isvideoopened: true });

      await this.props.markSummaryVideoOpened({
        studentcpid: this.props.match.params.id,
        isrepeated: false,
        repeatcount: 0,
        round: this.props.selectedCoursePlanObject.round,
      });

      return;
    }

    this.setState({ isvideocomplete: true });

    //total time spend till the time
    let ts = this.state.timespend;
    let starttime = this.state.starttime;
    var endtime = new Date();
    var diff = endtime.getTime() - starttime.getTime();
    var seconds = Math.floor(diff / 1000);
    //console.log("ts before calculate : ", ts);
    ts = ts + seconds;
    this.setState({ timespend: ts });
    //console.log("ts in calculated : ", seconds, ts);
    //-----------------------------------

    //check if any track is already exists
    await this.props.fetchSummaryTrack({
      studentcpid: params.id,
      isrepeated: false,
      repeatcount: 0,
      round: this.props.selectedCoursePlanObject.round,
    });

    this.setState({
      showReturnBtn: true,
      showConfetti: true,
      showReturnToCP: true,
    });

    //mark the CPO as complete
    await this.props.markSummaryAsComplete({
      studentcpid: params.id,
      isrepeated: false,
      repeatcount: 0,
      round: selectedCoursePlanObject.round,
      trackid: this.props.summarytrack ? this.props.summarytrack._id : "",
      totaltimespend: ts,
      playbackrate: this.state.playbacktxt,
      tutor: this.state.tutor,
      isreadcomplete: this.state.isreadcomplete,
      islistencomplete: this.state.islistencomplete,
      isvideocomplete: true,
    });
  };

  onPlaybackSpeedChange = (speed) => {
    //PlaybackRate
    let txt = "Normal";
    switch (speed) {
      case "75%":
        txt = "Slow";
        break;
      case "125%":
        txt = "Fast";
        break;
      case "150%":
        txt = "Very Fast";
        break;
      default:
        break;
    }
    this.setState({ playbackrate: speed, playbacktxt: txt });
  };

  handlePlayResumeSummary = async (startbegin = false) => {
    if (!started) {
      //document.getElementById("btnPause").setAttribute("disabled", "disabled");
      document
        .getElementsByClassName("btnPause")[0]
        .setAttribute("disabled", "disabled");
      document
        .getElementsByClassName("btnPause")[1]
        .setAttribute("disabled", "disabled");

      let browserText = this.state.content ? this.state.content : "";
      if (browserText === "") {
        // document.getElementById("btnPause").removeAttribute("disabled");

        document
          .getElementsByClassName("btnPause")[0]
          .removeAttribute("disabled");
        document
          .getElementsByClassName("btnPause")[1]
          .removeAttribute("disabled");

        message.error("This narrative has no content.");
        return;
      }

      if (startbegin === true) i = 0;
      browserText = browserText.replace(/<P>/g, "<p>");

      //find the current paragraph and set the state
      //if i is empty amd nothing has set then set the i value
      if (i === 0) {
        //Total Paragarphs
        let arrpara = browserText.trim().split("<p>");
        let totalpara =
          arrpara.length > 0
            ? arrpara.length === 1
              ? 1
              : arrpara.length - 1
            : 1;
        this.setState({ totalpara });

        let onparagraph = this.props.summarytrack
          ? this.props.summarytrack.onparagraphweb
            ? this.props.summarytrack.onparagraphweb === -1
              ? 1
              : this.props.summarytrack.onparagraphweb
            : 1
          : 1;

        if (startbegin === true) onparagraph = 1;

        //KIRAN(17sep2022): fix
        if (onparagraph > totalpara) onparagraph = totalpara;

        this.setState({ onparagraph: onparagraph });

        //if onparagraph then set i as per the value
        if (totalpara !== 1) {
          let sum = 0;
          for (let p = 0; p < onparagraph; p++) {
            sum += arrpara[p].length + 3; //<p>
          }
          i = sum;
        }

        //take if any before time
        let ts = this.props.summarytrack
          ? this.props.summarytrack.totaltimespendweb
            ? this.props.summarytrack.totaltimespendweb
            : 0
          : 0;
        this.setState({ timespend: ts });
        //console.log("ts in DB : ", ts);
      }

      //logic to split data into chunk
      contentlen = browserText.length;
      const chunkEnd = i === 0 ? 1000 : i - 1 + 1000;
      if (contentlen <= chunkEnd) {
        j = contentlen;
      } else {
        const safeSplit = lastSpaceOutsideTag(browserText, chunkEnd);
        //no tag-free space in this window means the content is malformed - play the
        //rest in one go rather than cutting mid-tag, which Polly would reject
        j = safeSplit > i ? safeSplit : contentlen;
      }

      //console.log(i, j);

      //browserText = browserText.substr(0,3000);
      browserText = browserText.substr(i, j - i);
      //---------------

      let formattedNarrative = browserText.replace(/\\n/g, " ");
      formattedNarrative = formattedNarrative.replace(
        /<p>/g,
        `<break strength='x-strong'/>`
      );

      if (formattedNarrative.indexOf("<keyword>Answer:") > -1) {
        const i1 = formattedNarrative.indexOf("<keyword>Answer:");
        const i2 = formattedNarrative.indexOf(".", i1);
        const mySubString = formattedNarrative.substring(i1, i2);
        const val = mySubString ? mySubString.split(" ").length : 0;
        const sec = val < 14 ? val / 2 : 7;

        formattedNarrative = formattedNarrative.replace(
          /<keyword>Answer:/g,
          `<break time='${sec}s'/>Answer:`
        );
      }

      formattedNarrative = formattedNarrative.replace(
        /<[keyword][^>]+>|\\\\n+/g,
        `<break time='1.5s'/>`
      );

      let params = {
        Text: `<speak><prosody rate="${this.state.playbackrate}">${formattedNarrative}</prosody></speak>`,
        OutputFormat: "mp3",
        VoiceId: this.state.tutor,
        TextType: "ssml",
        Engine: "neural",
      };

      //WEB Audio API usage
      //get speech data in the result
      const result = await utils.convertToPollySpeech(params);

      // Fix up prefixing
      window.AudioContext = window.AudioContext || window.webkitAudioContext;
      aContext = new AudioContext();

      //creates a sound source
      const source = aContext.createBufferSource();
      source.onended = function () {
        //mark the summary as complete
        document.getElementById("btnAutoStop").click();
      };

      //tell the source which sound to play
      source.buffer = await aContext.decodeAudioData(result);

      //connect the source to the context's destination (the speakers)
      source.connect(aContext.destination);

      //play the source now
      source.start();

      document.getElementsByClassName("btnPause")[0].innerText =
        aContext.state === "running" ? "Pause" : "Resume";

      document.getElementsByClassName("btnPause")[1].innerText =
        aContext.state === "running" ? "Pause" : "Resume";

      document
        .getElementsByClassName("btnPause")[0]
        .removeAttribute("disabled");
      document
        .getElementsByClassName("btnPause")[1]
        .removeAttribute("disabled");

      started = true;

      //start timer
      this.setState({ starttime: new Date() });
      //
    } else if (aContext.state === "running") {
      aContext.suspend().then(function () {
        document.getElementsByClassName("btnPause")[0].innerText = "Resume";
        document.getElementsByClassName("btnPause")[1].innerText = "Resume";
      });
    } else if (aContext.state === "suspended") {
      aContext.resume().then(function () {
        document.getElementsByClassName("btnPause")[0].innerText = "Pause";
        document.getElementsByClassName("btnPause")[1].innerText = "Pause";
      });
    }
  };

  removeHTMLTags = (str) => {
    if (!str) return "";
    return str.replace(/<(.|\n)*?>/g, "");
  };

  onTutorChange = (tutor) => {
    this.setState({ tutor: tutor });
  };

  onHandleBack = () => {
    this.setState({ action: "" });

    //stop the video
    if (this.state.videolink !== "") this.pauseVideo();
  };

  onHandleReadBack = () => {
    this.setState({ action: "" });
  };

  onHandleRead = () => {
    this.setState({ action: "read" });
  };

  onHandleTraditionalRead = () => {
    this.setState({ action: "traditionalread" });
  };

  onHandleBlastFlipRead = () => {
    this.setState({ action: "blastflipread" });
  };

  onHandleWatch = () => {
    //ADDED DIRECT ELSE PART
    this.setState({ action: "watch" });
  };

  onHandleListen = () => {
    //KIRAN(27oct2023): Bruce wanted to remove this rule
    // const { selectedCoursePlanObject, summarytrack } = this.props;
    // const { isreadcomplete } = this.state;

    // const isreadnarrative =
    //   (selectedCoursePlanObject &&
    //     selectedCoursePlanObject.status === "Completed") ||
    //   isreadcomplete === true ||
    //   (summarytrack && summarytrack.isreadcomplete === true)
    //     ? true
    //     : false;

    // if (isreadnarrative === false && selectedCoursePlanObject.round === 1) {
    //   toast.error(
    //     "Please finish reading the narrative and flipping all of the flip boxes before listening to the narrative."
    //   );
    // } else {
    //   this.setState({ action: "listen" });
    // }
    //ADDED DIRECT ELSE PART
    this.setState({ action: "listen" });
  };

  onHandleCPBack = () => {
    this.props.history.push(`${STUDENT_CONTENT_BASE_URL}`);
  };

  onBeforePlayResumeSummary = () => {
    //KIRAN(27oct2023): Bruce wanted to remove this rule
    // const { selectedCoursePlanObject, summarytrack } = this.props;
    // const { isreadcomplete } = this.state;

    // const isreadnarrative =
    //   (selectedCoursePlanObject &&
    //     selectedCoursePlanObject.status === "Completed") ||
    //   isreadcomplete === true ||
    //   (summarytrack && summarytrack.isreadcomplete === true)
    //     ? true
    //     : false;

    // if (isreadnarrative === false && selectedCoursePlanObject.round === 1) {
    //   toast.error(
    //     "Please finish reading the narrative and flipping all of the flip boxes before listening to the narrative."
    //   );
    // } else {
    //   this.handlePlayResumeSummary();
    // }
    //ADDED DIRECT ELSE PART
    this.handlePlayResumeSummary();
  };

  pauseVideo = () => {
    var iframeSrc = this.frameRef.current.src;
    this.frameRef.current.src = iframeSrc;
  };

  render() {
    const { selectedCoursePlanObject } = this.props;
    const {
      showReturnBtn,
      content,
      isbegin,
      action,
      contentwithflip,
      seekValue,
      tutor,
      showConfetti,
      showReturnToCP,
      fontSize,
      fontFamily,
      videolink,
      // onlylisten,
    } = this.state;

    const readinst = (
      <div>
        To increase your memory strength and test performance try guessing the
        word behind each Blast Flip Box. Then hover over the word to see if you
        are correct. Blast will change the color of each box you flip.
      </div>
    );

    return (
      <div className="blast-narrative">
        <div
          className={"active flip-card-main vh-100"}
          style={{ display: action === "" ? "" : "none" }}
        >
          <Container>
            <Row className="align-items-center vh-100">
              <Col lg={8} className="m-auto-custom">
                <div className="card-box m-auto p-5-custom bg-white text-center">
                  <div className="name-co mb-3 mt-4">
                    {selectedCoursePlanObject && selectedCoursePlanObject.cpoid
                      ? `${selectedCoursePlanObject.courseplanid.courseplanname} > ${selectedCoursePlanObject.cpoid.cponame}`
                      : "--"}
                  </div>
                  <h2>
                    How Do You Want To Study This{" "}
                    {selectedCoursePlanObject?.courseplanid
                      ?.authenticationcode === "STUDYPROJECT"
                      ? "Podcast"
                      : "Narrative"}
                    ?
                  </h2>
                  <div className="pt-3 mb-4">
                    <Link
                      to="#"
                      onClick={this.onHandleWatch}
                      className="nbtn nbtn-primary mb-3 w-80"
                      disabled={
                        selectedCoursePlanObject &&
                        selectedCoursePlanObject.cpoid
                          ? false
                          : true
                      }
                      style={{ display: videolink !== "" ? "" : "none" }}
                    >
                      Watch
                    </Link>

                    <Link
                      to="#"
                      onClick={this.onHandleListen}
                      className="nbtn nbtn-primary mb-3 w-80"
                      disabled={
                        selectedCoursePlanObject &&
                        selectedCoursePlanObject.cpoid
                          ? false
                          : true
                      }
                    >
                      Listen
                    </Link>

                    <Link
                      to="#"
                      onClick={this.onHandleBlastFlipRead}
                      className="nbtn nbtn-primary w-80"
                      // style={{ display: onlylisten === false ? "" : "none" }}
                    >
                      Read
                    </Link>
                  </div>
                  <Link
                    to="#"
                    onClick={this.onHandleCPBack}
                    className="btn btn-transparent p-0 mb-4"
                    style={{ float: "left", marginTop: "-10px" }}
                  >
                    <img
                      className="img-fluid me-2"
                      width={20}
                      src={Back}
                      alt="back"
                    />
                  </Link>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div
          className={"active flip-card-main vh-100"}
          style={{ display: action === "read" ? "" : "none" }}
        >
          <Container>
            <Row className="align-items-center vh-100">
              <Col lg={8} className="m-auto-custom">
                <div className="card-box m-auto p-5-custom bg-white text-center">
                  <h2>How Do You Want To Read This Narrative?</h2>

                  <div
                    data-show="true"
                    className="ant-alert ant-alert-info ant-alert-with-description"
                    role="alert"
                  >
                    <span
                      role="img"
                      aria-label="info-circle"
                      className="anticon anticon-info-circle ant-alert-icon"
                    >
                      <svg
                        viewBox="64 64 896 896"
                        focusable="false"
                        data-icon="info-circle"
                        width="1em"
                        height="1em"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
                        <path d="M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"></path>
                      </svg>
                    </span>
                    <div className="ant-alert-content">
                      <div className="ant-alert-description">
                        Blast Flip is the best choice for building strong long
                        term memories and better test performance. This is
                        because Blast Blast Flip uses the science of effortful
                        recall. Also, Blast Flip is fun!
                      </div>
                    </div>
                  </div>

                  <div className="pt-2 mb-2">
                    <Link
                      to="#"
                      onClick={this.onHandleTraditionalRead}
                      className="nbtn nbtn-primary mb-3 w-80"
                    >
                      Traditional Reading
                    </Link>

                    <Link
                      to="#"
                      onClick={this.onHandleBlastFlipRead}
                      className="nbtn nbtn-primary w-80"
                    >
                      Blast Flip Reading
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div
          className={
            action === "traditionalread"
              ? "active flip-card-main vh-100"
              : "flip-card-main vh-100"
          }
          style={{ display: action === "traditionalread" ? "" : "none" }}
        >
          <Container>
            <Row className="align-items-center vh-100">
              <Col lg={10} className="m-auto-custom">
                <div className="card-box m-auto p-5-custom bg-white text-left">
                  <Link
                    to="#"
                    onClick={this.onHandleReadBack}
                    className="btn btn-transparent p-0 mb-4"
                  >
                    <img
                      className="img-fluid me-2"
                      width={30}
                      src={Back}
                      alt="back"
                    />
                  </Link>
                  <span style={{ float: "right" }}>
                    <Tooltip
                      placement="topRight"
                      title={readinst}
                      color={"#038fde"}
                      key={"#038fde"}
                    >
                      <InfoCircleTwoTone
                        twoToneColor="#038fde"
                        style={{ fontSize: "20px" }}
                      />
                    </Tooltip>
                  </span>

                  <div
                    className="scroll-fix"
                    dangerouslySetInnerHTML={{
                      __html: content.replace(/\n/g, "<br />"),
                    }}
                  ></div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div
          className={
            action === "blastflipread"
              ? "active flip-card-main vh-100"
              : "flip-card-main vh-100"
          }
          style={{ display: action === "blastflipread" ? "" : "none" }}
        >
          <Container>
            <Row className="align-items-center vh-100">
              <Col lg={10} className="m-auto-custom">
                <div className="card-box m-auto p-5-custom bg-white text-left">
                  <Link
                    to="#"
                    onClick={this.onHandleReadBack}
                    className="btn btn-transparent p-0 mb-4"
                  >
                    <img
                      className="img-fluid me-2"
                      width={30}
                      src={Back}
                      alt="back"
                    />
                  </Link>

                  <span style={{ float: "right" }}>
                    <Tooltip
                      placement="topRight"
                      title={readinst}
                      color={"#038fde"}
                      key={"#038fde"}
                    >
                      <InfoCircleTwoTone
                        twoToneColor="#038fde"
                        style={{ fontSize: "20px" }}
                      />
                    </Tooltip>
                  </span>

                  <div
                    className="scroll-fix"
                    style={{ fontSize, fontFamily }}
                    dangerouslySetInnerHTML={{ __html: contentwithflip }}
                  ></div>

                  <div style={{ clear: "both" }}>&nbsp;</div>

                  <div className="d-flex action-Listen mb-3 scroll-fix">
                    <Tooltip title="Play/Resume Audio" placement="top">
                      <Button
                        className="nbtnread nbtn-primary me-1 btnPause"
                        id="btnPause"
                        onClick={this.onBeforePlayResumeSummary}
                      >
                        Play
                      </Button>
                    </Tooltip>

                    <Tooltip
                      title="Play/Resume Audio"
                      placement="top"
                      style={{
                        display: isbegin === true ? "inline" : "none",
                      }}
                    >
                      <Button
                        id="btnPlayBegin"
                        onClick={() => {
                          this.handlePlayResumeSummary(true);
                        }}
                        className="nbtnread nbtn-primary me-1  mx-2"
                      >
                        Play from Beginning
                      </Button>
                    </Tooltip>

                    <Tooltip title="Stop Audio" placement="top">
                      <Button
                        className="nbtnread nbtn-primary me-1  mx-2"
                        id="btnStop"
                        onClick={() => {
                          this.markSummaryAsComplete(false, "stop");
                        }}
                      >
                        Stop
                      </Button>
                    </Tooltip>

                    <Tooltip title="Playback Speed" placement="left">
                      <TreeSelect
                        dropdownClassName="cpo-select-dropdown"
                        showArrow={false}
                        className="select-drop-read mx-2"
                        defaultValue={this.state.playbackrate}
                        placeholder="Playback Rate"
                        onChange={this.onPlaybackSpeedChange}
                      >
                        <TreeNode value="75%" title="Slow" />
                        <TreeNode value="100%" title="Normal" />
                        <TreeNode value="125%" title="Fast" />
                        <TreeNode value="150%" title="Very Fast" />
                      </TreeSelect>
                    </Tooltip>

                    <Tooltip title="Set font size" placement="left">
                      <TreeSelect
                        dropdownClassName="cpo-select-dropdown"
                        showArrow={false}
                        className="select-drop-read select-drop--narrow mx-2"
                        defaultValue={fontSize}
                        onChange={(fontSize) => {
                          this.setState({ fontSize });
                          localStorage.setItem("fontSize", fontSize);
                        }}
                      >
                        {[10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30]?.map(
                          (val) => (
                            <TreeNode value={val} title={val} />
                          )
                        )}
                      </TreeSelect>
                    </Tooltip>

                    <Tooltip title="Set font family" placement="left">
                      <TreeSelect
                        dropdownClassName="cpo-select-dropdown"
                        style={{ minWidth: 175 }}
                        showArrow={false}
                        className="select-drop-read mx-2"
                        defaultValue={fontFamily}
                        onChange={(fontFamily) => {
                          this.setState({ fontFamily });
                          localStorage.setItem("fontFamily", fontFamily);
                        }}
                      >
                        {[
                          "Arial",
                          "Times New Roman",
                          "Courier New",
                          "Georgia",
                          "Palatino",
                          "Garamond",
                          "Comic Sans MS",
                          "Trebuchet MS",
                          "Arial Black",
                          "Impact",
                          "Lucida Sans Unicode",
                          "Tahoma",
                          "Verdana",
                          "Courier",
                          "Lucida Console",
                          "Roboto",
                        ]?.map((val) => (
                          <TreeNode value={val} title={val} />
                        ))}
                      </TreeSelect>
                    </Tooltip>

                    <Tooltip title="Tutor Name" placement="left">
                      <TreeSelect
                        dropdownClassName="cpo-select-dropdown"
                        showArrow={false}
                        className="select-drop-read mx-2"
                        defaultValue={tutor}
                        placeholder="Tutor"
                        onChange={this.onTutorChange}
                      >
                        <TreeNode value="Ruth" title="Ruth" />
                        <TreeNode value="Matthew" title="Matthew" />
                        <TreeNode value="Stephen" title="Stephen" />
                        <TreeNode value="Joanna" title="Joanna" />
                        <TreeNode value="Emma" title="Emma" />
                        <TreeNode value="Kimberly" title="Kimberly" />
                        <TreeNode value="Brian" title="Brian" />
                      </TreeSelect>
                    </Tooltip>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div
          className={
            action === "listen"
              ? "active flip-card-main vh-100"
              : "flip-card-main vh-100"
          }
          style={{ display: action === "listen" ? "" : "none" }}
        >
          <Container>
            <Row className="align-items-center vh-100">
              <Col lg={10} className="m-auto-custom">
                <div className="card-box m-auto p-5-custom bg-white text-left">
                  <Tooltip
                    title="Return back to narrative home"
                    placement="top"
                  >
                    {(showReturnBtn ||
                      selectedCoursePlanObject.status === "Completed") && (
                      <Link
                        to="#"
                        onClick={this.onHandleBack}
                        className="btn btn-transparent p-0 mb-4"
                      >
                        <img
                          className="img-fluid me-2"
                          width={30}
                          src={Back}
                          alt="back"
                        />
                      </Link>
                    )}
                  </Tooltip>

                  <div className="scroll-fix">
                    <div className="text-center mb-3">
                      <img
                        className="img-fluid m-auto"
                        width={150}
                        src={Audio}
                        alt="Audio"
                      />
                    </div>
                    <div className="d-flex action-Listen mb-3">
                      <Tooltip title="Play/Resume Audio" placement="top">
                        <Button
                          className="nbtn nbtn-primary me-1 btnPause"
                          id="btnPause"
                          onClick={this.handlePlayResumeSummary}
                        >
                          Play
                        </Button>
                      </Tooltip>

                      <Tooltip
                        title="Play/Resume Audio"
                        placement="top"
                        style={{
                          display: isbegin === true ? "inline" : "none",
                        }}
                      >
                        <Button
                          id="btnPlayBegin"
                          onClick={() => {
                            this.handlePlayResumeSummary(true);
                          }}
                          className="nbtn nbtn-primary me-1  mx-2"
                        >
                          Play from Beginning
                        </Button>
                      </Tooltip>

                      <Tooltip title="Stop Audio" placement="top">
                        <Button
                          className="nbtn nbtn-primary me-1  mx-2"
                          id="btnStop"
                          onClick={() => {
                            this.markSummaryAsComplete(false, "stop");
                          }}
                        >
                          Stop
                        </Button>
                      </Tooltip>

                      <Tooltip title="Playback Speed" placement="bottom">
                        <TreeSelect
                          dropdownClassName="cpo-select-dropdown"
                          showArrow={false}
                          className="select-drop mx-2"
                          defaultValue={this.state.playbackrate}
                          placeholder="Playback Rate"
                          onChange={this.onPlaybackSpeedChange}
                        >
                          <TreeNode value="75%" title="Slow" />
                          <TreeNode value="100%" title="Normal" />
                          <TreeNode value="125%" title="Fast" />
                          <TreeNode value="150%" title="Very Fast" />
                        </TreeSelect>
                      </Tooltip>

                      <Tooltip title="Tutor Name" placement="bottom">
                        <TreeSelect
                          dropdownClassName="cpo-select-dropdown"
                          showArrow={false}
                          className="select-drop mx-2"
                          defaultValue={tutor}
                          placeholder="Tutor"
                          onChange={this.onTutorChange}
                          style={{ paddingLeft: "0px" }}
                        >
                          <TreeNode value="Ruth" title="Ruth" />
                          <TreeNode value="Matthew" title="Matthew" />
                          <TreeNode value="Stephen" title="Stephen" />
                          <TreeNode value="Joanna" title="Joanna" />
                          <TreeNode value="Emma" title="Emma" />
                          <TreeNode value="Kimberly" title="Kimberly" />
                          <TreeNode value="Brian" title="Brian" />
                        </TreeSelect>
                      </Tooltip>
                    </div>
                    <div>
                      <Button
                        style={{ display: "none" }}
                        id="btnAutoStop"
                        onClick={() => {
                          this.markSummaryAsComplete(true);
                        }}
                      >
                        AutoStop
                      </Button>

                      <input
                        className="w-100 slider-bar"
                        type="range"
                        min="0"
                        max="100"
                        step="1"
                        value={seekValue}
                        onChange={(e) => {
                          //const seekto = contentlen * (+e.target.value / 100);
                          this.setState({ seekValue: e.target.value });
                        }}
                      />
                    </div>
                  </div>

                  {showReturnToCP && (
                    <div>
                      <Button
                        onClick={this.onHandleCPBack}
                        style={{ marginTop: 20 }}
                        type="primary"
                      >
                        Return to study plan
                      </Button>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div
          className={
            action === "watch"
              ? "active flip-card-main vh-100"
              : "flip-card-main vh-100"
          }
          style={{ display: action === "watch" ? "" : "none" }}
        >
          <Container>
            <Row className="align-items-center vh-100">
              <Col lg={10} className="m-auto-custom">
                <div className="card-box m-auto p-5-custom bg-white text-left">
                  <Tooltip
                    title="Return back to narrative home"
                    placement="top"
                  >
                    {(showReturnBtn ||
                      selectedCoursePlanObject.status === "Completed") && (
                      <Link
                        to="#"
                        onClick={this.onHandleBack}
                        className="btn btn-transparent p-0 mb-4"
                      >
                        <img
                          className="img-fluid me-2"
                          width={30}
                          src={Back}
                          alt="back"
                        />
                      </Link>
                    )}
                  </Tooltip>

                  <div className="text-center mb-3">
                    <ReactPlayer
                      ref={this.frameRef}
                      url={videolink}
                      controls={true}
                      height={"300px"}
                      onStart={() => {
                        this.onHandleVideoPlayEnd("start");
                      }}
                      onEnded={() => {
                        this.onHandleVideoPlayEnd("end");
                      }}
                    ></ReactPlayer>
                  </div>

                  {showReturnToCP && (
                    <div>
                      <Button
                        onClick={this.onHandleCPBack}
                        style={{ marginTop: 20 }}
                        type="primary"
                      >
                        Return to study plan
                      </Button>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {showConfetti && (
          <Confetti
            width={window.screen.width}
            height={window.screen.height}
            numberOfPieces={4000}
            tweenDuration={24000}
            recycle={false}
            onConfettiComplete={() => this.setState({ showConfetti: false })}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedCoursePlanObject: state.courseplans.selectedCoursePlanObject,
  summarytrack: state.summary.summarytrack,
});

const mapDispatchToProps = {
  fetchStudentCoursePlanObject,
  markSummaryAsComplete,
  markParaSummary,
  fetchSummaryTrack,
  markOpenSummary,
  markSummaryFlipped,
  markSummaryReadListenStatus,
  markSummaryVideoOpened,
};

export default connect(mapStateToProps, mapDispatchToProps)(Summary);
